import type { GetStaticProps } from 'next'
import type { Product } from '@/types'

import { Seo } from '@/components/generals/seo'
import { PageHero } from '@/components/layout/page-hero'
import { ShopGrid } from '@/components/shop/shop-grid'
import { getProducts } from '@/lib/content'

interface ShopPageProps {
    products: Product[]
}

export default function ShopPage({ products }: ShopPageProps) {
    return (
        <>
            <Seo
                title='Shop'
                description='Caps, beanies, tees, wallets, phone cases and totes from the studio.'
            />
            <PageHero titleTop='My' titleBottom='Shop' />
            <div className='section'>
                <div className='container'>
                    <ShopGrid products={products} />
                </div>
            </div>
        </>
    )
}

export const getStaticProps: GetStaticProps<ShopPageProps> = async () => {
    const products = await getProducts()
    return { props: { products }, revalidate: 60 }
}
